import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import * as HMS from "../../../common/component/Index";
import { FlagIcons } from '../../../common/component/TranslateButton';
import TourTicket from './../../../../../models/TourTicket';
import { withTranslation } from "react-i18next";
import { Icon, Menu } from 'antd';
import Dropdown from '../../../common/component/Dropdown';
import Modal from '../../../common/component/Modal';
import { TRANSLATE_LANGUAGE, PATHS } from "../../../../../constants/Define";
import * as ANT from 'antd';
import { find, toArray } from 'lodash';
import EllipsisText from '../../../common/component/EllipsisText';
import i18n from "../../../../../constants/initLng";

let permisionActions = [];
const ListCols = ['id', 'ticketCode', 'name', 'propertyName', 'shortDescription', 'isAvailable', 'translations'];

const ModelFields = Object.getOwnPropertyNames(new TourTicket());
class TourTicketList extends Component {
    state = {
        titleTable: Func.getTitleTable(ListCols, ['action'], ['id']),
        modelTourTicket: ModelFields,
        componentTable: {
            ticketCode: {
                key: 'ticketCode',
                width: 300,
                fixed: 'left',
                sorter: (i, k) => i.ticketCode.length - k.length,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            isAvailable: {
                title: this.props.t('item.tourTicket.available'),
                key: 'isAvailable',
                render: (status) => <HMS.StatusComponent color={status ? 'green' : 'red'}
                    label={status ? i18n.t('item.tourTicket.isAvailable') : i18n.t('item.tourTicket.isUnAvailable')} />,
                filters: [
                    { value: true, text: this.props.t('item.tourTicket.isAvailable') },
                    { value: false, text: this.props.t('item.tourTicket.isUnAvailable') }
                ],
                filterMultiple: false,
            },
            translations: {
                render: (text, record) => <FlagIcons languages={record.translations} />,
                key: 'languageCode',
                filters: toArray(TRANSLATE_LANGUAGE).map(lang => ({
                    value: lang.code, text: this.props.t(`translate.languages.${lang.id}`)
                })),
                filterMultiple: false,
            },
            action: {
                width: 90,
                align: 'center',
                fixed: 'right',
                render: (text, record) => this.renderEditComponent(record),
            }
        },
    };

    

    render() {
        const { t, loading, tourTickets, pagination } = this.props;
        const { titleTable, modelTourTicket, componentTable } = this.state;
        return (
            <HMS.ListComponent
                tableKey="table-list"
                // scroll={{ x: 1500 }}
                rowKey={record => record.id}
                loading={{ spinning: loading }}
                dataSource={Func.getDataSource(tourTickets, modelTourTicket)}
                columns={Func.columnsTable({
                    titleTable: titleTable,
                    component: componentTable,
                    itemName: 'tourTicket'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const removeTourTicket = () => {
            return this.props.onDelete && this.props.onDelete(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.tourTicket.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeTourTicket,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.TOUR_TICKET.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }
}

export default withTranslation()(TourTicketList);
